import { Col, List, Row } from "antd";
import { InputField, Panel, TextComponent } from "../../../components";
import styles from "./VendorPlanningFormOne.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { PdfIcon } from "../../../components/icons/Icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlanningTemplatesMiddleware } from "../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { FaCheckSquare, FaRegSquare } from "react-icons/fa";
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";

const VendorPlanningFormOne = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    state: { temp_id, parent_id, shared_planning_template_id },
  } = useLocation();
  const dispatch = useDispatch();
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const ViewResult = useSelector(
    (state) => state.PlanningTemplatesReducer.ViewResult
  );
  useEffect(() => {
    dispatch(
      PlanningTemplatesMiddleware.getViewResult({
        temp_id: temp_id,
        event_id: EventDetails?.id,
        parent_id: parent_id,
        shared_planning_template_id: shared_planning_template_id,
      })
    );
  }, []);

  // console.log("EventDetailsEventDetailsEventDetails", EventDetails);

  const renderSectionList = (item, index) => {
    return (
      <div className={styles.secListItem} key={item?.id}>
        <Panel name={item?.name}>
          {item?.questions?.map((ques, i) => {
            // console.log("ques", ques);

            return (
              <>
                <div className={styles.quesListItem}>
                  <TextComponent text={ques?.question} />
                </div>
                <div className={styles.answer}>
                  {ques?.type == "set_option" ||
                    ques?.type == "multiple_option" ? (
                    <div>
                      {ques?.options?.map((options, index) => {
                        return (
                          <div className={styles.optionItem}>
                            {ques?.type == "multiple_option" ? (
                              ques?.answer?.includes(options.name) ? (
                                <FaCheckSquare className={styles.optionIcon} />
                              ) : (
                                <FaRegSquare className={styles.optionIcon} />
                              )
                            ) : options?.name == ques?.answer ? (
                              <IoIosRadioButtonOn
                                className={styles.optionIcon}
                              />
                            ) : (
                              <IoIosRadioButtonOff
                                className={styles.optionIcon}
                              />
                            )}
                            <TextComponent
                              text={options?.name}
                              textClass={styles.optionText}
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <TextComponent
                      text={ques?.answer ? ques?.answer : "--"}
                      textClass={styles.optionText}
                    />
                  )}
                </div>
              </>
            );
          })}
        </Panel>
      </div>
    );
  };
  return (
    <div className={styles.pageContainer}>
      {/* <Col xs={24}> */}
      <div className={styles.mainRow}>
        {/* <Col xs={24} sm={16} md={12} lg={10} xl={8} className={styles.leftCol}> */}
        <div className={styles.leftColRow}>
          <Col>
            <TextComponent textClass={styles.infoHeading}>
              Venue Information
            </TextComponent>
          </Col>
          <Col>
            <Row
              className={styles.pdfDownloadRow}
              onClick={() =>
                navigate("/templateDetail/planningForm/2", {
                  state: {
                    headrTitle: "Planning Form",
                    ViewResult: ViewResult,
                    parent_id: parent_id,
                    temp_id: temp_id,
                    shared_planning_template_id: shared_planning_template_id,

                  },
                })
              }
            >
              <PdfIcon size={40} />
              <TextComponent textClass={styles.downloadText}>
                Download Pdf
              </TextComponent>
            </Row>
          </Col>
        </div>
        {/* </Col> */}
        {/* <Col xs={24} lg={14} xl={16}> */}
        <div className={styles.quesCol}>
          <List
            dataSource={ViewResult?.section ? ViewResult?.section : []}
            renderItem={renderSectionList}
            className={styles.sectionlist}
          />
        </div>
        {/* </Col> */}
      </div>
      {/* </Col> */}
    </div>
  );
};

export default VendorPlanningFormOne;
